import {
    scrollTo
} from '../../utils/_scrollTo';

export const displayDynamicShippingAlert = (html, type, pinType) => {
    if ('#error-message-expired-card') $('#error-message-expired-card').remove();
    var alertBox = '<div data-twist="error" id="error-message-expired-card" class="alert alert-';
    alertBox += type;
    alertBox += ' alert-dismissible" role="alert" aria-live="assertive"><button class="alert-dismiss close" type="button" data-dismiss="alert" data-twist="error-message-close-link">';
    alertBox += '<i aria-hidden="true">&times;</i><span class="sr-only">Close</span></button><div class="error-display-message">';
    alertBox += html;
    alertBox += '</div></div>';
    if (pinType != undefined && pinType.length > 0) {
        if (pinType == 'giftCard') {
            //$('#paymentPage').length > 0 ? $('.card.active').find('#giftCardMessage').append(alertBox) : $('#content-wrapper').prepend(alertBox);
            $('#giftCardMessageError').show();
            $('#giftCcard').focus().parents('.form-group').addClass('has-error');
            $('#giftCardMessageError').show();
            $('#giftCcard').on('blur', function () {
                $('#giftCardMessageError').hide();
                $('#giftCcard').parents('.form-group').removeClass('has-error');

            });
        } else if (pinType == 'rewardsCert') {
            //$('#paymentPage').length > 0 ? $('.card.active').find('#shoppingPassMessage').append(alertBox) : $('#content-wrapper').prepend(alertBox);
            $('#shoppingPassMessageError').show();
            $('#certificate-pass-promo-code').focus().parents('#rewards').find('.form-group').addClass('has-error');
            $('#certificate-pass-promo-code').on('blur', function () {
                $('#shoppingPassMessageError').hide();
                $('#certificate-pass-promo-code').parents('#rewards').find('.form-group').removeClass('has-error');

            });
        }
    } else {
        if($('#giftCardColumn').hasClass('gc-rewardError')) {
            if(alertBox.indexOf("Gift") > -1){
                $('#gift-cards').append(alertBox);
            }
            else{
                $("#rewards").append(alertBox);
            }
        } else {
            $('#paymentPage').length > 0 ? $('.card.active').find('.messages').append(alertBox) : $('#content-wrapper').append(alertBox);
        }
    }
    if ($("#error-message-expired-card").length > 0) {
        scrollTo('#error-message-expired-card');
    }
};


